import axios from 'axios'

export default {
  namespaced: true,
  state: {
    noticeList: [],
    noticeCount: 0,
    unReadNotice: 0
  },
  getters: {
    noticeList:(state) => state.noticeList,
    noticeCount:(state) => state.noticeCount,
    unReadNotice:(state) => state.unReadNotice
  },
  mutations: {
    get(state, data) {
      state.noticeList = data.data;
      state.noticeCount = data.count;
    },
    getUnReadNotice(state, data) {
      state.unReadNotice = data;
    },
    resetNotice(state) {
      state.noticeCount = 0;
      state.noticeList = [];
    }
  },
  actions: {
    async get({ commit }, page) {
      const response = await axios.get(process.env.VUE_APP_API_BASE_URL + '/notification' + '?page=' + page)
      commit('get', response.data)
    },
    async getUnReadNotice({ commit }) {
      const response = await axios.get(process.env.VUE_APP_API_BASE_URL + '/notification/unread_count')
      commit('getUnReadNotice', response.data.unread_count);
    },
    resetNotice({ commit }) {
      commit('resetNotice');
    }
  },
}